module.exports = __webpack_public_path__ + "static/media/UVGLogo.1ea9b7ab.png";